module.exports = __webpack_public_path__ + "img/21_25.ef4b2c6d.png";